import request from '@/utils/request';

// code换token
export function getCodeLogin(data :{[key: string]: any} = {}) {
    return request.post({
        url: 'v2/user/auth/code-login',
        data,
    });
}
